<template>
  <button
    v-if="video && !playing"
    type="button"
    class="yt-facade"
    :aria-label="title ? `Lire la vidéo : ${title}` : 'Lire la vidéo'"
    @click="playing = true"
  >
    <img
      class="yt-facade__thumb"
      :src="youtubeThumbnail(video.id).src"
      :srcset="youtubeThumbnail(video.id).srcset"
      :sizes="YOUTUBE_THUMBNAIL_SIZES"
      alt=""
      loading="lazy"
      decoding="async"
      fetchpriority="low"
      @load="fallbackYoutubeThumbnail($event.target as HTMLImageElement)"
      @error="fallbackYoutubeThumbnail($event.target as HTMLImageElement, true)"
    />
    <span
      class="yt-facade__play"
      aria-hidden="true"
    />
  </button>
  <iframe
    v-else-if="video"
    :src="youtubeAutoplayUrl(video.id, video.params)"
    :title="title || 'Vidéo YouTube'"
    frameborder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    allowfullscreen
    referrerpolicy="strict-origin-when-cross-origin"
  />
  <iframe
    v-else
    :src="src"
    frameborder="0"
  />
</template>

<script setup lang="ts">
// A YouTube player only loads on click (see utils/youtubeFacade.ts); other video hosts keep their iframe.
const props = defineProps<{
  src?: string
  title?: string
}>()

const video = computed(() => parseYoutubeEmbed(props.src))
const playing = ref(false)
</script>
